<template>
  <div v-title data-title="申请退款">
    <wv-cell
      title="退款原因"
      is-link
      :value="reason | pickerValueFilter"
      @click.native="applyreasonsPickershow = true"
    />
    <wvi-input
      label="备注"
      placeholder="备注"
      ref="1"
      v-model="memo"
      :validate-info="{errormsg:'备注不可为空'}"
      required
    ></wvi-input>
    <wv-picker
      :visible.sync="applyreasonsPickershow"
      :columns="applyreasons"
      value-key="label"
      v-model="reason"
      @confirm="confirmReason"
    />
    <wv-button
      @click="applyrefound()"
      type="primary"
      :mini="true"
      style="padding:0.31em  4.32em;background-color:rgb(255, 152, 0);color:white;width:100%;height:40px;position:fixed;bottom:0"
    >申请退款</wv-button>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";

export default {
  name: "applyrefound",

  data: function() {
    return {
      memo: "",
      reason: "",
      orderguid: "",
      applyreasonsPickershow: false,
      applyreasons: [
        {
          values: [],
          defaultIndex: 0
        }
      ]
    };
  },
  watch: {
    reason(val) {
      this.memo = val[0].label.toString();
    },
    applyreasonsPickershow(val) {
      if (val && this.reason == "") {
        this.reason = [];
        this.reason[0] = this.applyreasons[0].values[0];
      }
    }
  },
  created: function() {
    this.orderguid = this.$route.query.orderguid;
    var checkList = Vue.filter("filterdictbychecklist")(68);
    this.applyreasons[0].values = checkList;
    this.applyreasons[0].defaultIndex = 0;
  },
  methods: {
    applyrefound: function() {
      if (!this.validatesave()) {
        return;
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tborder/realthingapplyrefound", {
          params: { orderGuid: this.orderguid, reason: this.memo }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              Toast.success("申请退款成功");
              this.$router.push({
                path: "/page/orderdetail",
                query: {
                  OrderGuid: this.orderguid
                }
              });
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //验证
    validatesave: function() {
      var com = this.$refs;
      var flag = true;
      for (var c in com) {
        if (this.$refs[c] != undefined) {
          if (this.$refs[c].length != undefined) {
            this.$refs[c][0].validate();
            flag = this.$refs[c][0].valid;
          } else {
            this.$refs[c].validate();
            flag = this.$refs[c].valid;
          }
          if (!flag) return flag;
        }
      }
      return flag;
    },
    confirmReason: function(picker) {
      this.reason = picker.getValues();
    }
  },
  filters: {
    pickerValueFilter(val) {
      if (Array.isArray(val)) {
        return val[0].label.toString();
      } else {
        return "请选择";
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/order/applyrefound.vue